import { lang } from '@umu/ukit-lang';
import React, { Component } from 'react';
import { classSet } from '@umu/umu-dom';
import { IUserInfo } from '@umu/umu-types';
import { localStorageHelper, STORAGE_KEY } from '@umu/umu-storage';
import { components } from 'common';
const { If } = components;
import { UserAvatar, UserName } from '../index';

import './userPostInfo.scss';
import defaultAvatar from './images/defaultAvatar.png';

interface IProps {
    userInfo: IUserInfo;
    profileId: string;
    profileName: string;
    profileAvatar: string;
    userNick: string;
    isAnonymous: number;
    isAllowAnonymous: string;
    isCompletelyAnonymous: string;
    updateUserNick: (nick: string) => void;
    toggleAnonymous: (flag: boolean) => void;
}

export default class UserPostInfo extends Component<IProps, {}> {
    constructor(props: IProps) {
        super(props);

        this.state = {};

        this.toggleAnonymous = this.toggleAnonymous.bind(this);
        this.onUserNickChange = this.onUserNickChange.bind(this);
    }

    public UNSAFE_componentWillMount() {
        // 匿名策略为：
        //  登录状态下，使用了“匿名发言”时为【匿名】，否则为【非匿名】
        //  未登录状态下，由用户自己输入用户名，始终为【非匿名】
        const props = this.props;
        const savedUserName = localStorageHelper.get(STORAGE_KEY.POST_NAME) || '';
        // 强制匿名时，都为【匿名】
        if (props.isCompletelyAnonymous === '1') {
            props.updateUserNick && props.updateUserNick(lang('匿名用户'));
            props.toggleAnonymous(true);
        } else if (props.isAllowAnonymous === '1' && !!props.isAnonymous) {
            if (props.profileId) {
                props.updateUserNick && props.updateUserNick(lang('匿名用户'));
                props.toggleAnonymous(true);
            } else {
                props.updateUserNick && props.updateUserNick(savedUserName);
                props.toggleAnonymous(false);
            }
        } else {
            if (props.profileId) {
                props.updateUserNick && props.updateUserNick(props.profileName);
            } else {
                props.updateUserNick && props.updateUserNick(savedUserName);
            }
            props.toggleAnonymous(false);
        }
    }

    public componentDidMount() {
        const avatar = document.querySelector('.j_avatarImg');
        avatar &&
            avatar.addEventListener('error', () => {
                (avatar as HTMLImageElement).src = defaultAvatar;
            });
    }

    public toggleAnonymous() {
        const props = this.props;
        const isAnonymous = !props.isAnonymous;

        props.toggleAnonymous(isAnonymous);

        let nick = '';
        if (!isAnonymous) {
            nick = props.profileName;
        } else {
            nick = lang('匿名用户');
        }
        props.updateUserNick && props.updateUserNick(nick);
    }

    public onUserNickChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;
        const props = this.props;
        localStorageHelper.set(STORAGE_KEY.POST_NAME, value);
        props.updateUserNick && props.updateUserNick(value);
    }

    public renderCompletelyAnonymous = () => {
        return (
            <div className="questionaire-poster">
                <div className="userNameSetter hasIdentity">
                    <div className="userNameWrap">
                        <div className="avat">
                            <UserAvatar className="round avatar" src={''} width={40} />
                        </div>
                        <div className="userName fake">{lang('匿名用户')}</div>
                    </div>
                </div>
            </div>
        );
    }

    public renderQAUserInfo() {
        const props = this.props;
        const setterCls = classSet({
            'userNameSetter clearfix': true,
            'hasIdentity': !!props.profileId,
            'lite': !props.profileId,
        });

        const checkboxCls = classSet({
            'check-box': true,
            'checked': !!props.isAnonymous,
        });

        const avatar =
            props.profileId &&
            ((props.isAllowAnonymous === '1' && !props.isAnonymous) || props.isAllowAnonymous !== '1')
                ? props.profileAvatar
                : '';
        const userLevelInfo = props.userInfo.user_level;
        const userMedalInfo = props.userInfo.user_medal;
        const showUserLevel = props.isAnonymous ? 0 : props.userInfo.show_user_level;

        // isAllowAnonymous  0 是不允许，1是允许，默认是允许
        return (
            <div className="questionaire-poster">
                <div className={setterCls}>
                    <If condition={!!props.profileId && props.isAllowAnonymous === '1'}>
                        <div className="isAnonymous" onClick={this.toggleAnonymous}>
                            <div className={checkboxCls}>
                                <span className="input">
                                    <span className="i_check"></span>
                                </span>
                                <span className="option-detail"> {lang('匿名提交')}</span>
                            </div>
                        </div>
                    </If>
                    <div className="userNameWrap">
                        <div className="avat">
                            <If condition={!avatar}>
                                <UserAvatar
                                    className="round avatar"
                                    src=""
                                    width={40}
                                    key={avatar}
                                    userLevelInfo={userLevelInfo}
                                    showUserLevel={showUserLevel}
                                />
                            </If>
                            <If condition={!!avatar}>
                                <UserAvatar
                                    className="round avatar"
                                    src={avatar}
                                    width={40}
                                    key={avatar}
                                    userLevelInfo={userLevelInfo}
                                    showUserLevel={showUserLevel}
                                />
                            </If>
                        </div>
                        <If condition={!!props.profileId}>
                            <div className="userName fake">
                                <UserName
                                    name={props.userNick}
                                    className="data-user-name"
                                    userMedalInfo={userMedalInfo}
                                    showUserLevel={showUserLevel}
                                    transcate={true}
                                />
                            </div>
                        </If>
                        <If condition={!props.profileId}>
                            <div className="userName">
                                <div className="input input-text">
                                    <input
                                        type="text"
                                        maxLength={50}
                                        placeholder={lang('请输入昵称')}
                                        value={props.userNick}
                                        onChange={this.onUserNickChange}
                                    />
                                </div>
                            </div>
                        </If>
                    </div>
                </div>
            </div>
        );
    }

    public render() {
        const props = this.props;
        // isCompletelyAnonymous，展示姓名 = '0'，不展示姓名 = '1'
        if (props.isCompletelyAnonymous === '1') {
            return this.renderCompletelyAnonymous();
        }
        return this.renderQAUserInfo();
    }
}
